import { View } from '../types.js'
import { notify } from './notification-utils.js'

export const handleError = (view: View, error: unknown): void => {
    console.error(error)
    notifyError(view, (error as Error).message)
}

const notifyError = (view: View, message: string) => {
    notify({ view, type: 'error', text: message })
    view.update()
}
